import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../context/LoginContext";

const LoginForm = () => {
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { signInMail, user, error } = useLogin();
  const navigate = useNavigate();

  useEffect(() => {
    if (user != null) {
      navigate("/home");
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await signInMail({ email, password });
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <nav className="w-full bg-[#356674] shadow-sm">
        <div className="flex items-center justify-center p-4">
          <img src="/LOGOBLANCO.webp" className="w-[180px]" alt="Logo CCIA" />
        </div>
      </nav>

      <div className="flex-1 flex items-center justify-center px-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-sm">
          <h2 className="text-2xl font-bold text-gray-800 mb-1">Iniciar Sesión</h2>
          <p className="text-gray-500 text-sm mb-6">Sistema de Inventario — CCIA</p>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 rounded-lg mb-5">
              {error === "Invalid login credentials"
                ? "Correo o contraseña incorrectos."
                : error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <label className="flex flex-col gap-1 text-sm font-medium text-gray-700">
              Correo electrónico
              <input
                className="border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4691A6] focus:border-transparent transition"
                type="email"
                name="email"
                value={email}
                required
                placeholder="usuario@ccia.com.pe"
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <label className="flex flex-col gap-1 text-sm font-medium text-gray-700">
              Contraseña
              <input
                className="border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4691A6] focus:border-transparent transition"
                type="password"
                name="password"
                value={password}
                required
                placeholder="••••••••"
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
            <button
              className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-200 text-white font-semibold py-2.5 px-4 rounded-lg mt-2 disabled:opacity-60 disabled:cursor-not-allowed"
              type="submit"
              disabled={submitting}
            >
              {submitting ? "Ingresando..." : "Iniciar sesión"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
